<template>
  <div class="goods-bar-wrp" @click="onCheckBox(!isSelect)">
    <div class="goods-bar">
      <div v-if="hasCheckBox" class="check-box-wrp">
        <div class="check-box" :class="{ active: isSelect }">
          <transition name="van-fade">
            <van-icon class="success-icon" v-show="isSelect" color="#fff" name="success" />
          </transition>
        </div>
      </div>
      <div class="left-content">
        <van-image
          :style="{ width: goodsPicSize, height: goodsPicSize }"
          :src="hasGoodsShow ? goodsImage : goodsIconImg"
        />
        <div class="goods-content">
          <h2 :style="goodsTitleStyle" class="goods-title van-multi-ellipsis--l2">
            {{ hasGoodsShow ? goodsName || '商品名称' : '全部商品' }}
          </h2>
          <div>
            <span>{{ hasGoodsShow ? `¥${goodsPrice || 0}` : `${goodsCount || 0}件` }}</span>
          </div>
        </div>
      </div>
      <div v-if="hasRightArrow" @click="emits('clickRightArrow')">选择&nbsp;<van-icon color="#999" name="arrow" /></div>
      <div v-if="hasDelIcon" @click="emits('delete', goodsId)">
        <van-icon :size="transPxToRem(22)" name="delete-o" />
      </div>
    </div>
  </div>
</template>
<script setup>
import { toRefs, computed } from 'vue'
import { transPxToRem } from '@/utils'
import { Image as VanImage, Icon as VanIcon } from 'vant'
import goodsIconImg from '@/assets/img/goods.png'
const props = defineProps([
  'goodsId',
  'goodsImage',
  'goodsName',
  'goodsPrice',
  'goodsCount',
  'goodsCoverSize',
  'hasCheckBox',
  'hasRightArrow',
  'isSelect',
  'hasDelIcon'
])
const emits = defineEmits(['checkbox-change', 'delete', 'clickRightArrow'])

const { goodsId, goodsCount, goodsCoverSize } = toRefs(props)

const hasGoodsShow = computed(() => Boolean(goodsId.value))

const goodsTitleStyle = computed(() => ({
  height: hasGoodsShow.value ? transPxToRem(36) : transPxToRem(18),
  marginBottom: hasGoodsShow.value ? transPxToRem(10) : transPxToRem(0)
}))

const goodsPicSize = transPxToRem(hasGoodsShow.value ? goodsCoverSize.value : 32)

const onCheckBox = checked => {
  emits('checkbox-change', { checked, goodsId: goodsId.value })
}
</script>
<style lang="less">
.goods-bar-wrp {
  font-size: 12px;
  background-color: #fff;
  border-radius: 4px;
  color: var(--van-black-9);
  .goods-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .check-box-wrp {
      margin-right: 10px;
      .check-box {
        width: 16px;
        height: 16px;
        line-height: 16px;
        border: 1px solid var(--van-gray-5);
        text-align: center;
        border-radius: 2px;
      }
      .active {
        background-color: var(--van-primary-color);
        border: 1px solid var(--van-primary-color);
      }
    }
  }
  .left-content {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 10px;
    .goods-content {
      flex: 1;
      margin-left: 10px;
      color: var(--van-black-2);
      font-size: 14px;
      .goods-title {
        font-size: 14px;
        line-height: 18px;
        margin-top: 0;
        font-weight: 400;
      }
    }
  }
}
</style>
